import { render } from "./RemoteHandsList.vue?vue&type=template&id=acf2a616"
import script from "./RemoteHandsList.vue?vue&type=script&lang=js"
export * from "./RemoteHandsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__